import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  baseProfile: "tiny",
  version: "1.2",
  viewBox: "0 0 2577 812"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M900 0h60l19 3q90 15 155 77c75 71 100 174 83 274q0 2-2 2H790c12 39 39 69 75 88 28 15 60 20 92 19 43-2 84-21 117-48a2 2-46 0 1 3 0l103 79a2 2 0 0 1 0 3 307 307 0 0 1-532-91 304 304 0 0 1 81-329q73-66 171-77Zm33 146c-55-1-108 32-134 80l1 1h262c-27-48-75-79-129-81ZM1496 0h46c62 5 127 28 171 73l36 38 3 5a1 1 60 0 1-1 1l-104 82a3 3 49 0 1-4 0l-30-28c-31-21-65-34-102-31-23 2-55 13-61 38-7 24 19 36 37 42q16 6 33 10l81 19c76 18 156 66 175 147 10 44-2 87-28 121-32 42-80 70-129 85-132 40-269 3-356-105-1-2-1-3 1-5l101-79a2 2 0 0 1 3 0l10 10c44 42 104 60 164 56 19-2 42-7 58-17 13-8 24-28 18-44-7-17-29-27-45-33-33-12-67-19-100-27-28-6-53-15-78-28-59-30-113-87-104-159 1-10 3-21 6-31 25-85 116-133 199-140Zm726 359v257h-98V359l-1-1h-257v-98h258V3h98v257h258l-1 98h-257v1ZM313 432c29-48 52-100 70-154 28-82 48-171 62-258 1-5 4-4 8-4h144c4 0 6 1 6 5q-15 97-40 193c-32 124-81 249-158 353q-52 69-121 120l-34 23c-67 44-145 70-226 76h-5a1 1 6 0 1-1-1V636a1 1-5 0 1 1-2q105-15 187-81l1-1A1081 1081 0 0 1 22 23c-1-5 2-7 7-7h140c4 0 7 2 7 6 14 144 58 287 136 410h1Z"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "2479.8",
      cy: "546.8",
      r: "71.1",
      fill: "#16c0e9"
    }, null, -1)
  ])))
}
export default { render: render }